export default __webpack_public_path__ + "static/media/agent.a155ac45.svg";